import React, { useState } from 'react';
import Main from '../../../component/Main.jsx';
import SearchBtn from '../../../component/common/button/SearchBtn.jsx';
import NewDataGrid from '../../../component/common/dataGrid/NewDataGrid.jsx';
import NewCommonSelect from '../../../component/common/selectBox/NewCommonSelect.jsx';

const BdMisang = () => {

    const [searchParams, setSearchParams] = useState({
        searchFromdate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchTodate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchEmog: '',
        searchGrdc: '',
        searchLoca: '',
    });

    const searchParamsAdditional = {};

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...searchParams,
            [name]: value
        };
        setSearchParams(newParams);
    };

    const dataHead = ['지역', '병원명', '환자수', '총건수/총비율', '주소지', '발병일시', '보험유형', '내원수단', '질병여부', '의도성여부', '손상기전', '교통사고손상당사자', '교통사고보호장구', '내원경로', '최종진료구역', '주진료 응급의료센터', '전문의진료여부', '응급진료결과', '입원경로', '주진료과', '입원후결과']; //component화 
    const dataColumn = ['ANNYLOCA', 'ANNYDESC', 'ANNYTOTL', 'ANNYMIAL', 'ANNYZIPC', 'ANNYAKDT', 'ANNYIUKD', 'ANNYINMN', 'ANNYDGKD', 'ANNYARCF', 'ANNYARCS', 'ANNYTAIP', 'ANNYTSUK', 'ANNYINRT', 'ANNYAREA', 'ANNYMDCD', 'ANNYSDCD', 'ANNYEMRT', 'ANNYHSRT', 'ANNYDEPT', 'ANNYDCRT'];
    const apiCall = '/ptmiapi/gumto/gumBdmisang_search.do';
    const apiCntCall = '';
    const excelFileName = '미상데이터';
    const excelHead = [];

    const propsInfo = {
        dataHead: dataHead,
        dataColumn: dataColumn,
        apiCall: apiCall,
        apiCntCall: apiCntCall,
        excelFileName: excelFileName,
        excelHead: excelHead
    }

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false
    })

    const [pageInfo, setPageInfo] = useState({
        paginationTF: false,
        currentPage: 1,
        itemsPerPage: 50, // 한 페이지당 보여줄 데이터 수
        totalItems: 0 // 전체 데이터 수
    });

    return (
        <Main>
            <div className="com-search">
                <table>
                    <colgroup>
                        <col width="10%" />
                        <col width="20%" />
                        <col width="10%" />
                        <col width="20%" />
                        <col width="10%" />
                        <col width="20%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <NewCommonSelect
                                hospitalTF={true}
                                searchParams={searchParams}
                                handleInputChange={handleInputChange}
                            />
                        </tr>
                        <tr>
                            <th>
                                내원일시
                            </th>
                            <td colSpan={5}>
                                <input
                                    type="date"
                                    name="searchFromdate"
                                    value={searchParams.searchFromdate}
                                    onChange={handleInputChange}
                                />&nbsp;
                                ~
                                &nbsp;
                                <input
                                    type="date"
                                    name="searchTodate"
                                    value={searchParams.searchTodate}
                                    onChange={handleInputChange}
                                    min={searchParams.searchFromdate}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <SearchBtn
                propsInfo={propsInfo}
                state={state}
                setState={setState}
                searchParams={searchParams}
                searchParamsAdditional={searchParamsAdditional}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
            />
            <NewDataGrid
                propsInfo={propsInfo}
                state={state}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
            />
            <p>* 표준진료정보 항목 중 '미상'으로 입력되어진 항목의 건수와 입력 비율을 표시합니다.<br />
                * 미상데이터 비율이 5%가 초과하지 않도록 관리해 주십시오.</p>
        </Main>
    )
}

export default BdMisang;